import { Box } from '@mui/material'

interface SpeciesIconProps {
  isFish: boolean
  /** theme.spacing units */
  size?: number
}

// The species SVGs are white line art, so tint them with a mask (same approach as ShrimpSalesRecordBody)
const SpeciesIcon = ({ isFish, size = 2.5 }: SpeciesIconProps) => {
  const src = isFish ? '/static/icons/growth/fish.svg' : '/static/icons/growth/shrimp.svg'
  return (
    <Box
      aria-hidden
      sx={{
        width: (theme) => theme.spacing(size),
        height: (theme) => theme.spacing(size),
        flexShrink: 0,
        bgcolor: 'text.secondary',
        WebkitMaskImage: `url(${src})`,
        maskImage: `url(${src})`,
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
      }}
    />
  )
}

export default SpeciesIcon
